import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { injectable } from "tsyringe";
import { OfficialDispatchInjection } from "features/officialDispatch/di/OfficialDispatchInjection";
import { OfficialDispatchRequestEntity } from "../entities/OfficialDispatchRequestEntity";
import { OfficialDispatchResponseEntity } from "../entities/OfficialDispatchResponseEntity";
import { IOfficialDispatchRepository } from "../repositories/IOfficialDispatchRepository";
import { FilterUseCase } from "app/filters/domain/useCase/FilterUseCase";
import { FilterInjection } from "app/filters/di/FilterInjection";
import { FILTER_FEATURE } from "api/ApiPath";
import { CacheKeyEnum } from "utils/enums/CacheKeyEnum";
import { OverviewServiceItem } from "features/generals/domain/entities/OverviewServiceResponseEntity";

@injectable()
export class OfficialDispatchUseCase {
  private repo: IOfficialDispatchRepository;
  private filterUseCase: FilterUseCase;

  constructor() {
    this.repo = OfficialDispatchInjection.getRepo();
    this.filterUseCase = FilterInjection.getUseCase();
  }

  private checkParams(params: OfficialDispatchRequestEntity): OfficialDispatchRequestEntity {
    return {
      ...params,
    };
  }

  async getOfficialDispatches(
    params: OfficialDispatchRequestEntity
  ): Promise<ListBaseApiResponseModel<OfficialDispatchResponseEntity>> {
    return this.repo.getOfficialDispatches(this.checkParams(params));
  }

  async getServiceList(): Promise<Array<OverviewServiceItem>> {
    return (await this.filterUseCase.fetchListWithFeature({
      path: FILTER_FEATURE.SERVICE_LIST,
      isNeedFeature: true,
      savedKey: CacheKeyEnum.serviceList,
      params: {},
    })) || [];
  }
}

